import '@/assets/styles/main.scss';
import 'core-js';
import 'whatwg-fetch';
import 'currentscript';
import _ from 'lodash';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { psAxios } from '@patsnap/common-ps-http';
import setWebsitFont from 'library-@/utils/configure-website-font';
import { headerDefer, prepareTokenBase } from '../../../components/token-base';
import { PRESETS_TOKEN_BASE_FUNDATION } from '../../../components/token-base/presets';
import { getIsFreeView } from '../../../components/utils/patent-view-free-judgment-util';
import { initTransformCodeInterceptor } from 'library-@/apis/interceptors/transform_code.interceptor';
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import { ANALYTICS_URI } from 'library-@/config/apiConfig';
import { loadMicroApp, prefetchApps } from 'qiankun';
import { getLoginPageApi } from 'library-@/apis/account_api/account';
import { getHeaderLogoHref } from './utils/index';
import { getHasLoginPage } from '../../../components/utils/loginPageJudgmentUtil';
import { initLegalStatus } from 'library-@/components/legal-tag/legal-config';

// import 'library-@/registerServiceWorker';
window.qiankunSingleton = window.qiankunSingleton || {
    loadMicroApp,
    prefetchApps,
};

async function langGetter(lang) {
    let results = {};
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/cn.json'),
            import('CommonMessages/analytics-search-next/cn.json'),
            import('CommonMessages/common-errorcode/cn.json'),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/tw.json'),
            import('CommonMessages/analytics-search-next/tw.json'),
            import('CommonMessages/common-errorcode/tw.json'),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/en.json'),
            import('CommonMessages/analytics-search-next/en.json'),
            import('CommonMessages/common-errorcode/en.json'),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/jp.json'),
            import('CommonMessages/analytics-search-next/jp.json'),
            import('CommonMessages/common-errorcode/jp.json'),
        ]);
    }
    const data = results.reduce((obj, data) => _.merge(obj, data), {});
    return { [lang]: data };
}

Vue.use(VueI18n);

if (document.getElementById('header')) {
    Promise.all([
        headerDefer()
            .then(
                async (data) => {
                    if (getIsFreeView()) { return data; }
                    await prepareTokenBase({ ...PRESETS_TOKEN_BASE_FUNDATION });
                    return data;
                }
            )
            .then((data) => {
                const { setting, locale, headerService } = data;
                setWebsitFont(locale);
                psAxios.interceptors.request.use(config => {
                    config.headers['X-Site-Lang'] = locale;
                    return config;
                }, null);
                /* 获取国际化资源 */
                return langGetter(locale).then(messages => {
                    const i18n = new VueI18n({
                        messages,
                        locale
                    });
                    return { setting, i18n, headerService };
                });
            }),
        import(/* webpackChunkName: "create-app" */ './create-app'),
        initLegalStatus(),
    ]).then(async ([data, { default: createApp }]) => {
        const { setting, i18n: vueI18nInstance, headerService } = data;
        initTransformCodeInterceptor(vueI18nInstance);
        const isSpecialIp = _.get(headerService, 'account._info.special_ip', false);
        if (getHasLoginPage() && !isSpecialIp) {
            try {
                const homePage = await getLoginPageApi();
                headerService.logoHref = getHeaderLogoHref(homePage);
            } catch (err) {
                headerService.logoHref = ANALYTICS_URI;
            }
        } else {
            headerService.logoHref = ANALYTICS_URI;
        }

        Vue.mixin({
            data() {
                return {
                    headerService
                };
            },
            created() {
                this.$setting = setting;
            },
        });
        createApp('#header', { vueI18nInstance });
    });
}
